export default {
    methods:{
        convertArrayToObject(array){
            return array.filter(ft => ft.key !== undefined).reduce(
                (obj, item) => Object.assign(obj, { [item.key]: item.model }), {})
        },

        isToast(data){
            this.$toast.open({
                message: data['message'],
                type: data['type'] || 'success',
                duration: data['duration'] || 5000,
                dismissible: data['dismissible'] || true,
                position:data['position'] || 'top'
              });
            },
        b64EncodeUnicode(str) {
            return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
                function toSolidBytes(match, p1) {
                    return String.fromCharCode('0x' + p1);
            }));
        },
        getColorSeverity(id) {
            switch (id?.toString()) {
              case "5":
                return "#ff0000 !important";
              case "4":
                return "#fc7b03 !important";
              case "3":
                return "#fcbe03 !important";
              case "2":
                return "#27c42f !important";
              case "1":
                return "#2785c4 !important";
              default:
                return "#18B3D6 !important";
            }
          },
    }
}